module.exports = __webpack_public_path__ + "img/gtgshtitle.34ab902c.png";